import { GSelect } from 'tennders-common/form/components'
import useTranslation from 'next-translate/useTranslation'

const DistanceFilter = ({ setrange, range, dateRange, setdateRange }) => {
  const { t } = useTranslation()
  return (
    <div className="d-flex align-center">
      <GSelect
        name="dateRange"
        onSet={(val) => setdateRange(val)}
        value={dateRange}
        items={[
          {
            label: t('common:ALL'),
            value: -1
          },
          {
            label: t('transaction:insideDateRange'),
            value: 1
          }
        ]}
      />
      <GSelect
        name="range"
        onSet={setrange}
        value={range}
        items={[
          {
            label: '100 km',
            value: 100
          },
          {
            label: '200 km',
            value: 200
          },
          {
            label: '300 km',
            value: 300
          },
          {
            label: '400 km',
            value: 400
          },
          {
            label: '500 km',
            value: 500
          },
          {
            label: '1000 km',
            value: 1000
          },
          {
            label: '5000 km',
            value: 5000
          }
        ]}
      />
    </div>
  )
}

export default DistanceFilter
